import DarkModeIcon from "@mui/icons-material/DarkModeRounded";
import LightModeIcon from "@mui/icons-material/LightModeRounded";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useColorScheme } from "@mui/material/styles";
import { useState } from "react";

/** 跟随系统 / 浅色 / 深色。 */
export function ColorModeIconDropdown() {
  const { mode, systemMode, setMode } = useColorScheme();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  if (!mode) {
    return <Box sx={{ width: 28, height: 28 }} />;
  }
  const resolved = (mode === "system" ? systemMode : mode) ?? "light";
  const choose = (m: "system" | "light" | "dark") => () => {
    setMode(m);
    setAnchor(null);
  };
  return (
    <>
      <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} aria-label="切换主题">
        {resolved === "dark" ? <DarkModeIcon sx={{ fontSize: 17 }} /> : <LightModeIcon sx={{ fontSize: 17 }} />}
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={anchor !== null}
        onClose={() => setAnchor(null)}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        slotProps={{ paper: { variant: "outlined", elevation: 0, sx: { my: "4px" } } }}
      >
        <MenuItem selected={mode === "system"} onClick={choose("system")}>
          跟随系统
        </MenuItem>
        <MenuItem selected={mode === "light"} onClick={choose("light")}>
          浅色
        </MenuItem>
        <MenuItem selected={mode === "dark"} onClick={choose("dark")}>
          深色
        </MenuItem>
      </Menu>
    </>
  );
}
